// No invented company metrics. Add verified figures when available.
export const stats: { id: string; value: string; label: string; verified: boolean }[] = [];